module.exports = __webpack_public_path__ + "static/8.4_ancient_china-3fb089dd8a1c23064c66551987c8ff56.pdf";